// import React from 'react';
// import { Table, Progress, UncontrolledTooltip, Alert, Row, Col, Button } from 'reactstrap';
// import moment from 'moment/min/moment-with-locales';
// import * as utils from '../../Services/utils';
// import { withRouter } from 'react-router-dom';
// import * as applicantService from '../../Services/applicantService';
// import { InfoTag } from '../shared/infoTag';
// import ApplicantButtons from '../shared/applicantButtons';
// import { withTranslation, Trans } from 'react-i18next';
// import * as HelpMessages from '../../Services/helpMessages';
// import swal from 'sweetalert';
// import AssignedUserModal from '../../Components/Modals/assignedUserModal';
// import { createdByIcon, getStarColor } from '../../Helpers/applicantHelper';
// import { basicDateFormat } from '../../Helpers/dateTimeHelper';
// import ApplicantCompetence from '../shared/applicantCompetences';
// import { AssignedUserType } from '../../Components/Modals/assignedUserModal';

// class ApplicantsTable extends React.Component {
//   state = {
//     showModal: false,
//     applicant: {},
//   };

//   goToApplicant = async (applicant) => {
//     this.props.history.push(`/applications/details?applicantId=${applicant.id}&tab=applicationDetails`);

//     if (applicant.isNew) {
//       await this.dispatch.decreaseNumNewApplicants();
//     }
//   };

//   getApplicantTypeInfo(applicationType) {
//     if (applicationType === 'Open') {
//       return HelpMessages.getOpenApplicantsText(this.props.i18n.language);
//     } else if (applicationType === 'Bounded') {
//       return HelpMessages.getBoundedApplicantsText(this.props.i18n.language);
//     }

//     return applicationType;
//   }

//   deleteApplicant = (applicant) => {
//     const { t } = this.props;
//     swal({
//       title: t('applicants.DELETE_APPLICANT_TITLE'),
//       text: t('applicants.DELETE_APPLICANT_TEXT'),
//       icon: 'warning',
//       buttons: {
//         cancel: {
//           text: t('common.CANCEL'),
//           value: null,
//           visible: true,
//           closeModal: true,
//         },
//         confirm: {
//           text: t('common.DELETE'),
//           value: true,
//           visible: true,
//           closeModal: true,
//         },
//       },
//       dangerMode: true,
//     }).then((willArchive) => {
//       if (willArchive) {
//         applicant.status = 'Deleted';
//         applicantService.updateApplicantStatus(applicant.id, 'Deleted').then((response) => {
//           this.props.onStatusRefresh();
//         });
//       }
//     });
//   };

//   toggle = (applicant) => {
//     this.setState({ showModal: !this.state.showModal, applicant: applicant });
//   };

//   refreshStatus(application, newStatus) {
//     this.props.onStatusRefresh(application, newStatus);
//   }

//   setStarredApplicant(applicant) {
//     applicantService.setStarredApplicant(applicant.id).then(() => {
//       this.refreshStatus();
//     });
//   }

//   render() {
//     const { t } = this.props;
//     return (
//       <div>
//         {this.props.applicants.length > 0 ? (
//           <div>
//             <AssignedUserModal
//               showModal={this.state.showModal}
//               onToggle={(applicant) => this.toggle(applicant)}
//               onStatusRefresh={() => this.refreshStatus()}
//               applicant={this.state.applicant}
//               assignedUserType={AssignedUserType.AssignedToApplicant}
//             />
//             <div style={{ overflowX: 'auto', width: '100%' }}>
//               <Table striped bordered style={{ minWidth: '800px' }}>
//                 <thead>
//                   <tr>
//                     <th style={{ width: '100px' }}></th>
//                     <th hidden>ID</th>
//                     <th>{`${t('common.FIRST_NAME')}, ${t('common.LAST_NAME')}, ${t('common.E_MAIL')}`}</th>
//                     <th>{t('common.STATUS')}</th>
//                     <th>{t('competences.COMPETENCES')}</th>
//                     {this.props.forSpecificJob && <th>{t('common.SCORE')}</th>}
//                     <th>{t('applicants.D_O_B')}</th>
//                     <th>
//                       {t('common.TYPE')}
//                       &nbsp;
//                       <InfoTag id="allApplicants" lng={this.props.i18n.language}></InfoTag>
//                     </th>
//                     <th>{t('common.ADDED')}</th>
//                     <th>{t('common.MODIFIED')}</th>
//                     <th></th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {this.props.applicants.map((applicant, index) => (
//                     <tr key={applicant.id}>
//                       <td className="text-center">
//                         <b>{this.props.counting + index + 1}</b>&nbsp;
//                         <em
//                           id={'iconForNewApplicant'}
//                           className="fa fa-star far icon-hover-effect-no-color"
//                           onClick={() => this.setStarredApplicant(applicant)}
//                           style={{ cursor: 'pointer', color: getStarColor(applicant.isStarred) }}
//                         />
//                         {applicant.isNew && (
//                           <>
//                             <div className="badge badge-warning">{t('common.NEW')}</div>
//                           </>
//                         )}
//                       </td>
//                       <td style={{ width: '480px' }}>
//                         <div className="row">
//                           <div className="col-xs-2 ml-2">
//                             <div style={{ width: '60px', height: '60px' }}>
//                               <img
//                                 id="imgApplicantProfilePic"
//                                 src={
//                                   applicant.profilePicture
//                                     ? applicant.profilePicture
//                                     : 'img/user/user-dummy-300x300.png'
//                                 }
//                                 className="img-thumbnail rounded-circle"
//                                 alt={'Not found'}
//                               />
//                             </div>
//                           </div>
//                           <div className="col">
//                             <div className="row pointer-on-hover" onClick={() => this.goToApplicant(applicant)}>
//                               <div className="col-1">{createdByIcon(applicant.id, applicant.createdBy, t)}</div>
//                               <div className="col">
//                                 <h6 className="m-0 text-bold">
//                                   {applicant.firstName}
//                                   &nbsp;
//                                   {applicant.lastName}
//                                 </h6>
//                               </div>
//                             </div>
//                             <div className="row">
//                               <div className="col">{applicant.email}</div>
//                             </div>
//                             <div className="row">
//                               <div className="col">
//                                 <Trans i18nKey="jobs.ASSIGNED_TO" />
//                                 <Button color="primary" onClick={() => this.toggle(applicant)} outline size="xs">
//                                   <strong>{applicant.assignedTo}</strong>
//                                 </Button>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </td>
//                       <td className="text-center" style={{ width: '120px' }}>
//                         <Row>
//                           <Col>
//                             <ApplicantButtons
//                               applicant={applicant}
//                               onStatusRefresh={() => this.props.onStatusRefresh()}
//                             />
//                           </Col>
//                         </Row>
//                       </td>
//                       <td hidden>{applicant.id}</td>
//                       <td>
//                         {applicant.competencesForReturnDto &&
//                           applicant.competencesForReturnDto.map((competence, index) => (
//                             <ApplicantCompetence competence={competence} key={index} />
//                           ))}
//                       </td>
//                       {this.props.forSpecificJob && (
//                         <td>
//                           {/* {item.score}/{item.maxScore} */}
//                           <Progress
//                             className="progress-xs m-0"
//                             value={utils.calculatePercentage(applicant.score, applicant.maxScore)}
//                             color={utils.getColorForPercentage(
//                               utils.calculatePercentage(applicant.score, applicant.maxScore)
//                             )}
//                           />
//                           {utils.calculatePercentage(applicant.score, applicant.maxScore)}%
//                         </td>
//                       )}
//                       <td>
//                         {applicant.dateOfBirth !== '0001-01-01T00:00:00' ? (
//                           <>
//                             {moment.utc(applicant.dateOfBirth).format(basicDateFormat)}, {t('applicants.AGE')}:{' '}
//                             {moment().diff(applicant.dateOfBirth, 'years')}
//                           </>
//                         ) : null}
//                       </td>
//                       <td className="text-center" style={{ width: '100px' }}>
//                         <div
//                           id={`infoApplicant-${applicant.id}`}
//                           className={utils.getBadgeColor(applicant.applicantType)}
//                         >
//                           {utils.translateApplicantType(applicant.applicantType)}
//                         </div>
//                         <UncontrolledTooltip
//                           delay={{ show: 300, hide: 0 }}
//                           placement="left"
//                           target={`infoApplicant-${applicant.id}`}
//                         >
//                           {this.getApplicantTypeInfo(applicant.applicantType)}
//                         </UncontrolledTooltip>
//                       </td>
//                       <td>{moment.utc(applicant.created).locale('de').local().format('l')}</td>
//                       <td>{moment.utc(applicant.modified).local().fromNow()}</td>
//                       <td className="text-center" style={{ width: '140px' }}>
//                         <em
//                           id={`eyeButton-${index}`}
//                           style={{ cursor: 'pointer' }}
//                           className="fa-2x mr-2 fa fa-eye far icon-hover-effect-no-color"
//                           onClick={() => this.goToApplicant(applicant)}
//                         >
//                           <UncontrolledTooltip
//                             delay={{ show: 300, hide: 0 }}
//                             placement="left"
//                             target={`eyeButton-${index}`}
//                           >
//                             {t('common.DETAILS')}
//                           </UncontrolledTooltip>
//                         </em>
//                         <em
//                           id={`handbagButton-${index}`}
//                           style={{ color: 'gray' }}
//                           className="fa-2x mr-2 icon-handbag far icon-hover-effect-no-color"
//                           // onClick={() => this.findMostSuitableJobs(applicant.id)}
//                         >
//                           <UncontrolledTooltip
//                             delay={{ show: 300, hide: 0 }}
//                             placement="left"
//                             target={`handbagButton-${index}`}
//                           >
//                             {t('applicants.FIND_MOST_SUITABLE_JOBS')}
//                           </UncontrolledTooltip>
//                         </em>
//                         {applicant.status !== 'Deleted' && (
//                           <em
//                             id={`deleteButton-${index}`}
//                             style={{ cursor: 'pointer' }}
//                             className="fa-2x mr-2 fas fa-trash  far icon-hover-effect-no-color"
//                             onClick={() => this.deleteApplicant(applicant)}
//                           >
//                             <UncontrolledTooltip
//                               delay={{ show: 300, hide: 0 }}
//                               placement="left"
//                               target={`deleteButton-${index}`}
//                             >
//                               {t('common.DELETE')}
//                             </UncontrolledTooltip>
//                           </em>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           </div>
//         ) : (
//           <Alert color="success">
//             <em id="noApplicantsYetInfo" className="fa-x mr-2 icon-info">
//               <b>{t('applicants.NO_APPLICANTS_YET_INFO')}</b>
//             </em>
//           </Alert>
//         )}
//       </div>
//     );
//   }
// }
// export default withRouter(withTranslation('translations')(ApplicantsTable));
import React, { useState, useCallback } from 'react';
import { Table, Progress, UncontrolledTooltip, Alert, Row, Col, Button } from 'reactstrap';
import moment from 'moment/min/moment-with-locales';
import * as utils from '../../Services/utils';
import { useHistory } from 'react-router-dom';
import * as applicantService from '../../Services/applicantService';
import { InfoTag } from '../shared/infoTag';
import ApplicantButtons from '../shared/applicantButtons';
import { useTranslation, Trans } from 'react-i18next';
import * as HelpMessages from '../../Services/helpMessages';
import swal from 'sweetalert';
import AssignedUserModal from '../../Components/Modals/assignedUserModal';
import { createdByIcon, getStarColor } from '../../Helpers/applicantHelper';
import { basicDateFormat } from '../../Helpers/dateTimeHelper';
import ApplicantCompetence from '../shared/applicantCompetences';
import { AssignedUserType } from '../../Components/Modals/assignedUserModal';

const ApplicantsTable = (props) => {
  const { t, i18n } = useTranslation('translations');
  const history = useHistory();
  const { applicants, counting, forSpecificJob, onStatusRefresh } = props;

  const [showModal, setShowModal] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState({});

  const goToApplicant = useCallback(
    async (applicant) => {
      history.push(`/applications/details?applicantId=${applicant.id}&tab=applicationDetails`);
      if (applicant.isNew && props.dispatch && props.dispatch.decreaseNumNewApplicants) {
        await props.dispatch.decreaseNumNewApplicants();
      }
    },
    [history, props.dispatch]
  );

  const getApplicantTypeInfo = useCallback(
    (applicationType) => {
      if (applicationType === 'Open') {
        return HelpMessages.getOpenApplicantsText(i18n.language);
      } else if (applicationType === 'Bounded') {
        return HelpMessages.getBoundedApplicantsText(i18n.language);
      }
      return applicationType;
    },
    [i18n.language]
  );

  const deleteApplicant = useCallback(
    (applicant) => {
      swal({
        title: t('applicants.DELETE_APPLICANT_TITLE'),
        text: t('applicants.DELETE_APPLICANT_TEXT'),
        icon: 'warning',
        buttons: {
          cancel: {
            text: t('common.CANCEL'),
            value: null,
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: t('common.DELETE'),
            value: true,
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: true,
      }).then((willArchive) => {
        if (willArchive) {
          applicant.status = 'Deleted';
          applicantService.updateApplicantStatus(applicant.id, 'Deleted').then(() => {
            onStatusRefresh();
          });
        }
      });
    },
    [t, onStatusRefresh]
  );

  const toggle = useCallback((applicant) => {
    setShowModal((prev) => !prev);
    setSelectedApplicant(applicant);
  }, []);

  const refreshStatus = useCallback(
    (application, newStatus) => {
      onStatusRefresh(application, newStatus);
    },
    [onStatusRefresh]
  );

  const setStarredApplicant = useCallback(
    (applicant) => {
      applicantService.setStarredApplicant(applicant.id).then(() => {
        refreshStatus();
      });
    },
    [refreshStatus]
  );

  return (
    <div>
      {applicants.length > 0 ? (
        <div>
          <AssignedUserModal
            showModal={showModal}
            onToggle={(applicant) => toggle(applicant)}
            onStatusRefresh={() => refreshStatus()}
            applicant={selectedApplicant}
            assignedUserType={AssignedUserType.AssignedToApplicant}
          />
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <Table striped bordered style={{ minWidth: '800px' }}>
              <thead>
                <tr>
                  <th style={{ width: '100px' }}></th>
                  <th hidden>ID</th>
                  <th>{`${t('common.FIRST_NAME')}, ${t('common.LAST_NAME')}, ${t('common.E_MAIL')}`}</th>
                  <th>{t('common.STATUS')}</th>
                  <th>{t('competences.COMPETENCES')}</th>
                  {forSpecificJob && <th>{t('common.SCORE')}</th>}
                  <th>{t('applicants.D_O_B')}</th>
                  <th>
                    {t('common.TYPE')}&nbsp;
                    <InfoTag id="allApplicants" lng={i18n.language} />
                  </th>
                  <th>{t('common.ADDED')}</th>
                  <th>{t('common.MODIFIED')}</th>
                </tr>
              </thead>
              <tbody>
                {applicants.map((applicant, index) => (
                  <tr key={applicant.id}>
                    <td className="text-center">
                      <b>{counting + index + 1}</b>&nbsp;
                      <em
                        id="iconForNewApplicant"
                        className="fa fa-star far icon-hover-effect-no-color"
                        onClick={() => setStarredApplicant(applicant)}
                        style={{ cursor: 'pointer', color: getStarColor(applicant.isStarred) }}
                      />
                      {applicant.isNew && <div className="badge badge-warning">{t('common.NEW')}</div>}
                    </td>
                    <td style={{ width: '480px' }}>
                      <div className="row">
                        <div className="col-xs-2 ml-2">
                          <div style={{ width: '60px', height: '60px' }}>
                            <img
                              id="imgApplicantProfilePic"
                              src={
                                applicant.profilePicture ? applicant.profilePicture : 'img/user/user-dummy-300x300.png'
                              }
                              className="img-thumbnail rounded-circle"
                              alt="Not found"
                            />
                          </div>
                        </div>
                        <div className="col">
                          <div className="row pointer-on-hover" onClick={() => goToApplicant(applicant)}>
                            <div className="col-1">{createdByIcon(applicant.id, applicant.createdBy, t)}</div>
                            <div className="col">
                              <h6 className="m-0 text-bold">
                                {applicant.firstName} &nbsp; {applicant.lastName}
                              </h6>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">{applicant.email}</div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <Trans i18nKey="jobs.ASSIGNED_TO" />
                              <Button color="primary" onClick={() => toggle(applicant)} outline size="xs">
                                <strong>{applicant.assignedTo}</strong>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="text-center" style={{ width: '120px' }}>
                      <Row>
                        <Col>
                          <ApplicantButtons applicant={applicant} onStatusRefresh={() => onStatusRefresh()} />
                        </Col>
                      </Row>
                    </td>
                    <td hidden>{applicant.id}</td>
                    <td>
                      {applicant.competencesForReturnDto &&
                        applicant.competencesForReturnDto.map((competence, idx) => (
                          <ApplicantCompetence competence={competence} key={idx} />
                        ))}
                    </td>
                    {forSpecificJob && (
                      <td>
                        <Progress
                          className="progress-xs m-0"
                          value={utils.calculatePercentage(applicant.score, applicant.maxScore)}
                          color={utils.getColorForPercentage(
                            utils.calculatePercentage(applicant.score, applicant.maxScore)
                          )}
                        />
                        {utils.calculatePercentage(applicant.score, applicant.maxScore)}%
                      </td>
                    )}
                    <td>
                      {applicant.dateOfBirth !== '0001-01-01T00:00:00' ? (
                        <>
                          {moment.utc(applicant.dateOfBirth).format(basicDateFormat)}, {t('applicants.AGE')}:{' '}
                          {moment().diff(applicant.dateOfBirth, 'years')}
                        </>
                      ) : null}
                    </td>
                    <td className="text-center" style={{ width: '100px' }}>
                      <div
                        id={`infoApplicant-${applicant.id}`}
                        className={utils.getBadgeColor(applicant.applicantType)}
                      >
                        {utils.translateApplicantType(applicant.applicantType)}
                      </div>
                      <UncontrolledTooltip
                        delay={{ show: 300, hide: 0 }}
                        placement="left"
                        target={`infoApplicant-${applicant.id}`}
                      >
                        {getApplicantTypeInfo(applicant.applicantType)}
                      </UncontrolledTooltip>
                    </td>
                    <td>{moment.utc(applicant.created).locale('de').local().format('l')}</td>
                    <td>
                      <div className="d-flex justify-content-between">
                        <span>{moment.utc(applicant.modified).local().fromNow()}</span>
                        <span>
                          <em
                            id={`eyeButton-${index}`}
                            style={{ cursor: 'pointer' }}
                            className="fa-2x mr-2 fa fa-eye far icon-hover-effect-no-color"
                            onClick={() => goToApplicant(applicant)}
                          >
                            <UncontrolledTooltip
                              delay={{ show: 300, hide: 0 }}
                              placement="left"
                              target={`eyeButton-${index}`}
                            >
                              {t('common.DETAILS')}
                            </UncontrolledTooltip>
                          </em>
                          <em
                            id={`handbagButton-${index}`}
                            style={{ color: 'gray' }}
                            className="fa-2x mr-2 icon-handbag far icon-hover-effect-no-color"
                          >
                            <UncontrolledTooltip
                              delay={{ show: 300, hide: 0 }}
                              placement="left"
                              target={`handbagButton-${index}`}
                            >
                              {t('applicants.FIND_MOST_SUITABLE_JOBS')}
                            </UncontrolledTooltip>
                          </em>
                          {applicant.status !== 'Deleted' && (
                            <em
                              id={`deleteButton-${index}`}
                              style={{ cursor: 'pointer' }}
                              className="fa-2x mr-2 fas fa-trash far icon-hover-effect-no-color"
                              onClick={() => deleteApplicant(applicant)}
                            >
                              <UncontrolledTooltip
                                delay={{ show: 300, hide: 0 }}
                                placement="left"
                                target={`deleteButton-${index}`}
                              >
                                {t('common.DELETE')}
                              </UncontrolledTooltip>
                            </em>
                          )}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      ) : (
        <Alert color="success">
          <em id="noApplicantsYetInfo" className="fa-x mr-2 icon-info">
            <b>{t('applicants.NO_APPLICANTS_YET_INFO')}</b>
          </em>
        </Alert>
      )}
    </div>
  );
};

export default ApplicantsTable;
